/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from "react";
import HeadPage from "pages/StepPages/StepFour/HeadPage";
import sass from "./threat.module.sass";
import { Search } from "components-new";
import { Button } from "components/shared";
import ModalPortal from "components-new/ModalPortal";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import useDebounce from "hooks/useDebounce";
import InputTemp from "components-new/InputTemp";
import { useValidate } from "hooks/useValidate";
import Textarea from "components-new/Textarea";
import DropMenu from "pages/StepPages/StepFour/One/Tables/TableNavigate/DropMenu";
import { ReactComponent as ActionMenuIcon } from "images/ActionMenuIcon.svg";
import { AxiosError } from "axios";
import { useLocation } from "react-router-dom";
import { snackWrapper } from "../../../helpers";
import { useAppDispatch } from "../../../toolkit/hooks";
import { checkCompletingReferences } from "../../../toolkit/references/references.thunks";
import {directoryAPI} from "../../../libs/apiClient/Directory";
import {userAPI} from "../../../libs/apiClient/User";
import {ThreatShortInfo} from "../../../libs/apiClient/data-contracts";

const initial: ITypeThreat = {
	number: "",
	name: "",
	description: "",
	influence: "",
	sources: "",
};
const Modal: React.FC<{
	rootFunc: Dispatch<SetStateAction<ITypeThreat[]>> | Dispatch<SetStateAction<ITypeThreat[] | null>>;
	trigger: { active: boolean; data: ITypeThreat | null };
	cancelWindow: () => void;
}> = ({ trigger, rootFunc, cancelWindow }) => {
	const [newType, setNewType] = useState<ITypeThreat>(initial);
	const dispatch = useAppDispatch();
	useEffect(() => {
		if (trigger.data) {
			setNewType({ ...trigger.data, number: trigger.data?.number.replace(/\D/g, "") });
		} else {
			setNewType(initial);
		}
	}, [trigger]);

	const [errors, setErrors] = useState<any[]>([]);

	const send = () => {
		if (!trigger.data) {
			const {id,...rest} = newType
			directoryAPI.threatCreate({ ...rest, number: "УБИ." + rest.number,description:rest.description!,influence:rest.influence!,sources:rest.sources! })
				.then((r) => {
					snackWrapper("success","Запись успешно создана");
					rootFunc((prevState: any) => [...prevState, r.data]);
					dispatch(checkCompletingReferences());
					cancelWindow();
				})
				.catch((e: AxiosError) => {
					// @ts-ignore
					setErrors(e?.response?.data || []);
					// if (e.status === 409) {
					//
					// }
				});
		} else {
			const { id, ...rest } = newType;
			directoryAPI.threatUpdate(id!, { ...rest, number: "УБИ." + rest.number,description:rest.description!,influence:rest.influence!,sources:rest.sources! })
				.then((r) => {
					snackWrapper("success","Запись успешно создана");
					dispatch(checkCompletingReferences());
					rootFunc((prevState: any) => [...prevState].map((_) => (_.id === r.data.id ? { ...r.data } : _)));
					cancelWindow();
				})
				.catch((e: AxiosError) => {
					// @ts-ignore
					setErrors(e?.response?.data || []);
					// if (e.status === 409) {
					//
					// }
				});
		}
	};
	const { validate, error } = useValidate(newType, ["name", "number", "influence", "sources", "description"], send);

	const changeNumberUBI = (evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		let value: string,
			name = evt.target.name;

		value = evt.target.value.replace(/[^0-9]/g, "");
		if (Number(value) > 999) {
			value = "999";
		}
		evt.target.value = value;
		setNewType((prevState) => ({ ...prevState, [name]: value }));
	};

	const changeField = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		setNewType((prevState) => ({ ...prevState, [name]: value }));
	};
	useEffect(() => {
		return () => {
			setErrors([]);
			setNewType(initial);
		};
	}, []);

	const focusWithErrors = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>) => {
		const name: keyof typeof initial = e.target.name as any;
		if (errors.length && errors.includes(name)) {
			const index = errors.indexOf(name);
			setErrors((prevState) => {
				prevState.splice(index, 1);
				return prevState;
			});
			setNewType((prevState) => ({ ...prevState, [name]: initial[name] }));
		}
	};

	return trigger.active ? (
		<ModalPortal
			size={"md"}
			outSide={false}
			title={trigger.data ? "Редактировать последствие реализации угроз" : "Создать последствие реализации угроз"}
			handleClose={cancelWindow}>
			<div className={sass.modal}>
				<InputTemp
					maxLength={3}
					onChange={changeNumberUBI}
					name={"number"}
					error={(error && !newType.number) || errors.includes("number")}
					errorText={errors.includes("number") ? "Такой номер уже есть" : ""}
					value={newType.number}
					onFocus={focusWithErrors}
					placeholder={"Введите текст"}
					label={"Номер"}
					required
				/>
				<InputTemp
					onChange={changeField}
					name={"name"}
					error={(error && !newType.name) || errors.includes("name")}
					value={newType.name}
					onFocus={focusWithErrors}
					placeholder={"Введите текст"}
					label={"Наименование"}
					required
				/>
				<Textarea
					rows={7}
					onChange={changeField}
					name={"description"}
					error={(error && !newType.description) || errors.includes("description")}
					onFocus={focusWithErrors}
					value={newType.description||''}
					placeholder={"Введите текст"}
					label={"Описание угрозы"}
					required
				/>
				<Textarea
					rows={3}
					onChange={changeField}
					name={"sources"}
					error={(error && !newType.sources) || errors.includes("sources")}
					onFocus={focusWithErrors}
					value={newType.sources||''}
					placeholder={"Введите текст"}
					label={"Источники угрозы"}
					required
				/>
				<InputTemp
					onChange={changeField}
					name={"influence"}
					error={(error && !newType.influence) || errors.includes("influence")}
					value={newType.influence||''}
					onFocus={focusWithErrors}
					placeholder={"Введите текст"}
					label={"Объект воздействия"}
					required
				/>
				<div className={sass.btns}>
					<Button onClick={cancelWindow} variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button onClick={validate}>Готово</Button>
				</div>
			</div>
		</ModalPortal>
	) : null;
};

interface ITypeThreat extends Omit<ThreatShortInfo, 'id'>{
	id?: number;
}

const ThreatsReference = () => {
	const [data, setData] = useState<ITypeThreat[]>([]);
	const dispatch = useAppDispatch();
	const [filter, setFilter] = useState<ITypeThreat[] | null>(null);

	useEffect(() => {
		directoryAPI.threatListList().then((r) => setData(r.data));
	}, []);
	const [modal, setModal] = useState<{ active: boolean; data: ITypeThreat | null }>({ active: false, data: null });

	const [search, setSearch] = useState("");

	const query = useDebounce(search, 400);
	const location = useLocation();
	useEffect(() => {
		if (query as string) {
			directoryAPI.threatListList({query}).then((r) => setFilter(r.data));
		} else if (query === "") {
			setFilter(null);
		}
	}, [query]);

	const [target, setTarget] = useState<HTMLOrSVGElement | undefined>();

	const toggleTarget = (e: React.MouseEvent<HTMLOrSVGElement>) => {
		e.stopPropagation();
		target ? setTarget(undefined) : setTarget(e.currentTarget);
	};

	const removeItem = () => {
		const id = target?.dataset.id;
		directoryAPI.threatDelete(+id!)
			.then(() => {
				setData((prevState) => [...prevState].filter((_) => _.id !== Number(id)));
				snackWrapper("success","Запись удалена");
				dispatch(checkCompletingReferences());
				setTarget(undefined);
			})
			.catch((error) => {
				if (error.response.status === 500) {
					snackWrapper("error","Удаление невозможно, этот тип уже используется");
				}
				setTarget(undefined);
			});
	};

	const menuRef = useRef<any>(null);

	useEffect(() => {
		function handleClickOutside(event: any) {
			if (menuRef.current && target && !menuRef.current.contains(event.target)) {
				setTarget(undefined);
			}
		}

		document.addEventListener("mouseup", handleClickOutside);
		return () => {
			document.removeEventListener("mouseup", handleClickOutside);
		};
	}, [target]);
	const outlineStyle = useCallback(
		(id: number) => {
			return location.state && location.state.outline && location.state.outline === id ? sass.outline : "";
		},
		[location],
	);

	const [disabled, setDisabled] = useState(false);
	const needRule = useCallback(() => {
		if (disabled) snackWrapper("error", "Не достаточно прав");
	}, [disabled]);
	useEffect(() => {
		userAPI.permissionsCheckCreate(0, ["dictionary.threat.edit"])
			.then((r) => setDisabled(!r.data.length));
	}, []);
	return (
		<div className={sass.wrapper}>
			<DropMenu ref={menuRef} target={target} click={removeItem} />
			<Modal
				rootFunc={filter && filter.length ? setFilter : setData}
				trigger={modal}
				cancelWindow={() => setModal((prevState) => ({ ...prevState, active: false }))}
			/>
			<HeadPage title={"Угрозы"}>
				<div className={sass.head}>
					<Search className={sass.search} searchValue={search} handleSearch={(e) => setSearch(e.target.value)} />
					<Button disabled={disabled} onClick={() => setModal({ active: true, data: null })}>
						Добавить значение
					</Button>
				</div>
			</HeadPage>
			<table>
				<thead>
					<tr>
						<th>Номер</th>
						<th>Наименование</th>
						<th>Описание угрозы</th>
						<th>Источники угрозы</th>
						<th>Объект воздействия</th>
						<th />
					</tr>
				</thead>
			</table>
			<div data-comment-false={true} className={sass.scroll}>
				<table>
					<tbody>
						{filter
							? filter.map((_, index) => (
									<tr
										className={outlineStyle(_.id!)}
										onClick={() => (disabled ? needRule() : setModal({ active: true, data: _ }))}
										key={index}>
										<td>{_.number}</td>
										<td>{_.name}</td>
										<td>{_.description}</td>
										<td>{_.sources}</td>
										<td>{_.influence}</td>
										<td>
											<ActionMenuIcon data-id={_.id} onClick={toggleTarget} />
										</td>
									</tr>
							  ))
							: data.map((_, index) => (
									<tr
										className={outlineStyle(_.id!)}
										onClick={() => (disabled ? needRule() : setModal({ active: true, data: _ }))}
										key={index}>
										<td>{_.number}</td>
										<td>{_.name}</td>
										<td>{_.description}</td>
										<td>{_.sources}</td>
										<td>{_.influence}</td>
										<td>
											<ActionMenuIcon data-id={_.id} onClick={toggleTarget} />
										</td>
									</tr>
							  ))}
					</tbody>
				</table>
			</div>
		</div>
	);
};
export default ThreatsReference;
